import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ROUTES } from '@/config/app.config';
import { getAccessToken } from '@/infrastructure/services/api-client';
import { AdminRoute } from '@/presentation/components/AdminRoute';
import { NotificationSnackbar } from '@/presentation/components/NotificationSnackbar';
import { ProtectedRoute } from '@/presentation/components/ProtectedRoute';
import { MainLayout, PublicLayout } from '@/presentation/layouts';
import { AdminDomainsPage } from '@/presentation/pages/AdminDomainsPage';
import { AdminUsersPage } from '@/presentation/pages/AdminUsersPage';
import { ApiKeysPage } from '@/presentation/pages/ApiKeysPage';
import { DashboardPage } from '@/presentation/pages/DashboardPage';
import { LandingPage } from '@/presentation/pages/LandingPage';
import { LoginPage } from '@/presentation/pages/LoginPage';
import { ProfilePage } from '@/presentation/pages/ProfilePage';
import { PurchasePage } from '@/presentation/pages/PurchasePage';
import { RegisterPage } from '@/presentation/pages/RegisterPage';
import { SapEnvironmentsPage } from '@/presentation/pages/SapEnvironmentsPage';
import { SetupGuidePage } from '@/presentation/pages/SetupGuidePage';
import { useAuthStore } from '@/stores/use-auth-store';

function App() {
    const { isAuthenticated, refreshProfile } = useAuthStore();

    useEffect(() => {
        if (isAuthenticated && getAccessToken()) {
            void refreshProfile();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route element={<PublicLayout />}>
                    <Route path={ROUTES.home} element={<LandingPage />} />
                    <Route path={ROUTES.login} element={<LoginPage />} />
                    <Route path={ROUTES.register} element={<RegisterPage />} />
                </Route>

                {/* Protected routes */}
                <Route element={<MainLayout />}>
                    <Route
                        path={ROUTES.dashboard}
                        element={
                            <ProtectedRoute>
                                <DashboardPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.setupGuide}
                        element={
                            <ProtectedRoute>
                                <SetupGuidePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.apiKeys}
                        element={
                            <ProtectedRoute>
                                <ApiKeysPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.sapEnvironments}
                        element={
                            <ProtectedRoute>
                                <SapEnvironmentsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.profile}
                        element={
                            <ProtectedRoute>
                                <ProfilePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.purchase}
                        element={
                            <ProtectedRoute>
                                <PurchasePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={ROUTES.adminUsers}
                        element={
                            <AdminRoute>
                                <AdminUsersPage />
                            </AdminRoute>
                        }
                    />
                    <Route
                        path={ROUTES.adminDomains}
                        element={
                            <AdminRoute>
                                <AdminDomainsPage />
                            </AdminRoute>
                        }
                    />
                </Route>
            </Routes>
            <NotificationSnackbar />
        </BrowserRouter>
    );
}

export default App;
